<template lang="pug">
  #dashboard.page
    StatisticData
    .columns
      .column.is-3.is-4-desktop.is-12-mobile(v-for="card of cards" :key="card.link")
        DashCard(:card="card")
    .columns
      .column.is-3.is-4-desktop.is-12-mobile
        CounterWidget(:bets="bets" @range="countForecasts")
      .column.is-3.is-4-desktop.is-12-mobile
        UsersWidget(:users="users.list" :total="users.total")
      .column.is-3.is-4-desktop.is-12-mobile
        SubscriptionsWidget(:subscriptions="subscriptions.history" :total="subscriptions.total")
</template>

<script>
import SubscriptionsWidget from "@/components/SubscriptionsWidget";
import CounterWidget from "@/components/CounterWidget";
import UsersWidget from "@/components/UsersWidget";
import DashCard from "@/components/DashCard";
import Log from "@/components/Log";
import StatisticData from '../components/StatisticData.vue';

export default {
  name: "home",
  components: {
    StatisticData,
    SubscriptionsWidget,
    CounterWidget,
    UsersWidget,
    DashCard,
    Log
  },
  data() {
    return {
      logs: [
        {
          _id: 1,
          type: "error",
          date: new Date(),
          category: "Live",
          message: "Ошибка при получении списка матчей"
        },
        {
          _id: 2,
          type: "success",
          date: new Date(),
          category: "Users",
          message: "Новый пользователь “User” "
        },
        {
          _id: 3,
          type: "success",
          date: new Date(),
          category: "Subscription",
          message: "Пользователь “User” приобрел подписку “1 month”"
        }
      ]
    };
  },
  computed: {
    users() {
      return {
        list: this.$store.state.users.list.slice(0, 5),
        total: this.$store.state.users.counter.total
      };
    },
    subscriptions() {
      return this.$store.state.subscription;
    },
    bets() {
      return this.$store.state.forecast.counter.map(date => {
        // eslint-disable-next-line fp/no-mutation
        date.total = date.bets.reduce(
          (num, item) => num + item.success + item.failure,
          0
        );
        return date;
      });
    },
    liveCard() {
      const levels = this.$store.getters.matchTimeCounter.live;
      return {
        title: "Live",
        icon: "fa-bolt",
        link: "/live",
        total: this.$store.state.live.stat.count.all,
        data: Object.keys(levels).reduce(
          (obj, lvl) => [...obj, { title: `Level ${lvl}`, count: levels[lvl] }],
          []
        )
      };
    },
    usersCard() {
      const counter = this.$store.state.users.counter;
      return {
        title: "Users",
        icon: "fa-users",
        link: "/users",
        total: counter.total,
        data: [
          { title: "1 week", count: counter.week },
          { title: "1 month", count: counter.month }
        ]
      };
    },
    subCard() {
      const counter = this.subscriptions.counter;
      return {
        title: "Subscription",
        icon: "fa-money-check-alt",
        link: "/subscription",
        total: counter.total,
        data: [
          { title: "Today", count: counter.today },
          { title: "Week", count: counter.week },
          { title: "Month", count: counter.month }
        ]
      };
    },
    cards() {
      return [this.liveCard, this.usersCard, this.subCard];
    }
  },
  methods: {
    countForecasts(range) {
      this.$store.dispatch("countForecasts", range);
    }
  }
};
</script>

<style lang="scss" scoped>
.logs-container {
  margin: 2rem 0;
}
</style>
